import { ajax } from "../ajax";
import { ReqType as reqType } from "../config";

//登录API
export const loginApi = (params) => {
  // console.log('loginApi', params);
  let bodyFormData = new FormData();
  bodyFormData.append("username", params["username"]);
  bodyFormData.append("password", params["password"]);
  return ajax("/sys/login", bodyFormData, reqType.POST);
};

//退出登录API
export const logoutApi = async () => {
  return ajax("/sys/user/logout");
};

//刷新Token
export const refreshTokenApi = async () => {
  return ajax("/sys/user/reFreshToken");
};
